export default __webpack_public_path__ + "static/media/profile_picture_example.00861595.jpg";